export default __webpack_public_path__ + "static/background-b571d9f10849e59bc4ccc805dd4a7a9a.png";